import { sessionPrefix } from "./helpers";

export const projectNewsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/project-news`;
export const editProjectNewsPath = (session: LightSessionInterface, news: ProjectNewsRef) =>
  `${sessionPrefix(session)}/project-news/${news.id}`;
